import { render, staticRenderFns } from "./IconXCircleBg.vue?vue&type=template&id=5d567ce9"
import script from "./IconXCircleBg.vue?vue&type=script&lang=js"
export * from "./IconXCircleBg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports